<div class="main_body">
  <div class="contents contents--license">
    <h2 class="contents__title" i18n="@@pages.license.title">ビルド情報</h2>
    <h5 i18n="@@pages.license.description">
      本アプリケーションは以下の日時にビルドされました。<br>
      GOKURI Cloud Build on {{ buildDate | date:'yyyy-MM-dd HH:mm:ss' }}
    </h5>
  </div>
</div>
